document.addEventListener("DOMContentLoaded",function(){

const headings=document.querySelectorAll(".pb-article h2");

const toc=document.getElementById("pb-toc-list");

if(headings.length && toc){

headings.forEach(function(h,i){

const id="section-"+i;

h.id=id;

const li=document.createElement("li");

const a=document.createElement("a");

a.href="#"+id;

a.innerText=h.innerText;

li.appendChild(a);

toc.appendChild(li);

});

}

});